import React from 'react';
import { HeartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-800 text-white py-8 px-4" data-id="element-112">
      <div className="container mx-auto max-w-5xl" data-id="element-113">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-114">
          <motion.div className="mb-4 md:mb-0" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-115">
            <a href="#" className="text-2xl font-bold" data-id="element-116">
              ADIATU Habeeb
            </a>
          </motion.div>
          <motion.div className="flex flex-wrap justify-center mb-4 md:mb-0" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-117">
            <motion.a href="#home" className="mx-3 hover:text-purple-400 mb-2 md:mb-0" whileHover={{
            scale: 1.1,
            color: '#c084fc'
          }} data-id="element-118">
              Home
            </motion.a>
            <motion.a href="#about" className="mx-3 hover:text-purple-400 mb-2 md:mb-0" whileHover={{
            scale: 1.1,
            color: '#c084fc'
          }} data-id="element-119">
              About
            </motion.a>
            <motion.a href="#skills" className="mx-3 hover:text-purple-400 mb-2 md:mb-0" whileHover={{
            scale: 1.1,
            color: '#c084fc'
          }} data-id="element-120">
              Skills
            </motion.a>
            <motion.a href="#projects" className="mx-3 hover:text-purple-400 mb-2 md:mb-0" whileHover={{
            scale: 1.1,
            color: '#c084fc'
          }} data-id="element-121">
              Projects
            </motion.a>
            <motion.a href="#contact" className="mx-3 hover:text-purple-400 mb-2 md:mb-0" whileHover={{
            scale: 1.1,
            color: '#c084fc'
          }} data-id="element-122">
              Contact
            </motion.a>
          </motion.div>
          <motion.div className="flex space-x-4" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-123">
            <motion.a href="#" className="text-gray-400 hover:text-white" aria-label="GitHub" whileHover={{
            scale: 1.2,
            color: '#ffffff'
          }} data-id="element-124">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-125">
                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-126"></path>
              </svg>
            </motion.a>
            <motion.a href="#" className="text-gray-400 hover:text-white" aria-label="LinkedIn" whileHover={{
            scale: 1.2,
            color: '#ffffff'
          }} data-id="element-127">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-128">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-129" />
              </svg>
            </motion.a>
            <motion.a href="#" className="text-gray-400 hover:text-white" aria-label="Twitter" whileHover={{
            scale: 1.2,
            color: '#ffffff'
          }} data-id="element-130">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-131">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-132" />
              </svg>
            </motion.a>
          </motion.div>
        </div>
        <motion.div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} data-id="element-133">
          <motion.p className="flex items-center justify-center" whileHover={{
          color: '#c084fc'
        }} data-id="element-134">
            Made with <HeartIcon size={16} className="mx-1 text-red-500" data-id="element-135" /> by
            ADIATU Habeeb
          </motion.p>
          <p className="mt-2" data-id="element-136">
            © {currentYear} ADIATU Habeeb. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>;
}